/**
 * The width of the chat inbox drawer.
 */
export const DRAWER_WIDTH_REM = 22;
/**
 * The margin of the chat inbox drawer.
 */
export const DRAWER_MARGIN_REM = 1;
/**
 * The height of the chat inbox drawer header.
 */
export const DRAWER_HEADER_HEIGHT_REM = 3.5;
/**
 * The width of the chat box when it is open.
 */
export const CHAT_BOX_OPEN_WIDTH_PX = 480;
/**
 * The width of the chat box when it is minimised.
 */
export const CHAT_BOX_CLOSED_WIDTH_REM = 16;
/**
 * The spacing between chat boxes.
 */
export const SPACING_PX = 12;
